import CatalogoFamilia from "../catalogoFamilia/catalogoFamilia";
import "./detallesConstructivos.scss";

export default function DetallesConstructivos() {
    return (
        <CatalogoFamilia
            title="Detalles constructivos"
            className="detalles-constructivos"
            codFamilia={10}
        />
    );
}
